import * as HttpService from "../../../../service/HttpService"

/**
 * 获取单位下第一个用户的基本信息
 * @param customId 客户id
 */
export const getCustByOrgno = () => {
    return HttpService.get(HttpService.DOMAIN + "/userView/getCustByOrgNo");
}


/**
 * 获取当前用户下的电容柜
 * @param customId 客户id
 */
export const getDrg = (customId) => {
    return HttpService.get(HttpService.DOMAIN + "/userView/getCapacitanceArkByCust?id=" + customId);
}

/**
 * 获取当前用户下的母排
 * @param customId 客户id
 */
export const getMp = (customId) => {
    return HttpService.get(HttpService.DOMAIN + "/userView/getBusbarByCust?id=" + customId);
}

/**
 * 获取当前用户下的电量曲线
 * @param customId 客户id
 */
export const getPower = (customId,type) => {
    return HttpService.get(HttpService.DOMAIN + "/userView/getPowerByCust?id=" + customId + "&type=" + type);
}

/**
 * 获取当前用户下的负荷曲线
 * @param customId 客户id
 */
export const getEload = (customId) => {
    return HttpService.get(HttpService.DOMAIN + "/userView/getEloadByCust?id=" + customId);
}

/**
 * 获取当前用户下的功率因数曲线
 * @param customId 客户id
 */
export const getEloadFactor = (customId) => {
    return HttpService.get(HttpService.DOMAIN + "/userView/getPowerFactorByCust?id=" + customId);
}

/**
 * 获取摄像头信息
 * @param customId 客户id
 */
export const getCamera = (customId) => {
    return HttpService.get(HttpService.DOMAIN + "/userView/getMondevCameraByCust?id=" + customId);
}

/**
 * 获取中粮默认的6条总线曲线
 * @param customId 客户id
 */
export const getElec = () => {
    return HttpService.get(HttpService.DOMAIN + "/userView/getCurrent");
}

/**
 * 获取中粮默认的两条总线曲线
 * @param customId 客户id
 */
export const getZldmElec = () => {
    return HttpService.get(HttpService.DOMAIN + "/userView/getZldmCurrent");
}
